import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import {
    getMotifAvenantDemandeTarifInit,
    getCoefCommercialDemandeTarifInit,
    getSource,
} from '../../../../../../redux/selectors/init/init.selectors';
import CoefCommercialSlider from './CoefCommercialSlider';

const mapStateToProps = (state) => {
    const selector = formValueSelector('devis-avenant');
    return {
        source: getSource(state),
        motifAvenant: selector(state, 'DemandeTarif[Police][MotifAvenant]') || getMotifAvenantDemandeTarifInit(state),
        coefCommercialInit: getCoefCommercialDemandeTarifInit(state),
    };
};

// postReloadTarif, data et query sont passés via {...props} depuis le parent
const CoefCommercialSliderContainer = connect(mapStateToProps)(CoefCommercialSlider);

export default CoefCommercialSliderContainer;
